import { createInstance } from "@amplitude/analytics-browser";
const instance = createInstance();
export { instance as amplitude };

